
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tops",
      function () {
        return require("private-next-pages/tops.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tops"])
      });
    }
  